import { r as register } from './swiper-element-bundle-C6yW3Oh8.js';
import './a11y-F8w-t6Vr.js';
import './pagination-Dw_1wJjf.js';
import './autoplay-qizOvqdu.js';
import './thumbs-DDNPYh3W.js';

register();

const initSlider = () => {
  const swiperEl = document.querySelector('.hero-slider');
  if (!swiperEl) return;

  const params = {
    injectStyles: [
      `
        .swiper-pagination {
          position: absolute;
          bottom: 8px !important;
          left: 0;
          right: 0;
          background: white;
          max-width: max-content;
          margin: 0 auto;
          display: flex;
          align-items: center;
          gap: 4px;
          padding: 4px;
          border-radius: 8px;

          @media (min-width: 1024px) {
            bottom: 26px !important;
          }
        }

        .swiper-pagination-bullet {
          display: block;
          width: 24px;
          height: 4px;
          border-radius: 4px;
          margin: 0;
          padding: 0;
          border: none;
          background: var(--swiper-pagination-bullet-bg-color) !important;
          opacity: 100% !important;
          transition: all 0.3s ease-in-out;
        }

        .swiper-pagination-bullet-active {
          width: 40px;
          height: 4px;
          border-radius: 4px;
          background: var(--swiper-pagination-bullet-active-bg-color) !important;
        }
        `,
    ],
    pagination: {
      clickable: true,
      renderBullet: function (index, className) {
        return (
          '<button type="button" aria-label="Slide ' +
          (index + 1) +
          '" class="' +
          className +
          '"></button>'
        );
      },
    },
  };

  Object.assign(swiperEl, params);
  swiperEl.initialize();
};

// Initialize on page load
initSlider();

// Reinitialize when Shopify editor makes changes
document.addEventListener('shopify:section:load', initSlider);
